module.exports = __webpack_public_path__ + "img/car-green.708aeb1b.svg";